import { makeObservable, action, observable } from "mobx";
import { Loadable } from "./models/Loadable.mjs";
class SettingsStore {
  constructor(apiService) {
    this.apiService = apiService;
    makeObservable(this, {
      config: observable,
      load: action.bound
    });
  }
  config;
  load() {
    this.config = Loadable.toLoadable(this.apiService.getSettings());
  }
}
export {
  SettingsStore as default
};
